// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-CartTrigger__cartCounter__root"};